import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {Box, TextField} from "@mui/material";
import Loading from "../../../../../ui/Loading";
import {CustomAxiosError} from "../../../../../../logics/api_config";
import {useToast} from "../../../../../../utils/contexts/toast-context";
import MuiAutocomplete from "../../../../../ui/mui/mui-input/MuiAutoComplete";
import {
    IPaymentDiscountRate
} from "../../../../../../utils/interfaces/my_documents/fiscal_registry/payment/IPaymentDiscountRate";
import useApiGetDiscountRates from "./api-hooks/useApiGetDiscountRates";
import useApiGetDiscountRate from "./api-hooks/useApiGetDiscountRate";


interface Props {
    obj: IPaymentDiscountRate | undefined,
    onChange: (obj: IPaymentDiscountRate | undefined) => void,
    className: string,
    label?: string,
    required?: boolean
}

const PaymentDiscountRateSelect = ({
                                       obj: initialObj,
                                       label,
                                       onChange,
                                       required,
                                   }: Props) => {

    const {displayError} = useToast()
    const {t} = useTranslation()


    const [objs, setObjs] = useState<IPaymentDiscountRate[]>([]);
    const [obj, setObj] = useState<IPaymentDiscountRate | undefined>(initialObj)


    useEffect(() => {
        setObj(undefined);
        if (initialObj) {
            setObj(initialObj)
        }
    }, [initialObj]);


    const {
        data,
        isLoading,
        error,
    } = useApiGetDiscountRates();
    if (error) {
        const axiosError = error as CustomAxiosError;
        displayError(axiosError.response.data.detail);
    }


    useEffect(() => {
        if (data) {
            setObjs(data)
        }
    }, [data]);


    const {
        data: detailedObj,
    } = useApiGetDiscountRate(obj?.id);

    useEffect(() => {
        if (detailedObj) {
            setObj(detailedObj);
        }
    }, [detailedObj]);

    const handleOnChange = (event: React.SyntheticEvent, newValue: IPaymentDiscountRate | null) => {
        if (newValue) {
            onChange(newValue);
        } else {
            onChange(undefined);
        }
    };

    useEffect(() => {
        onChange(obj);
    }, [obj]);


    return (
        <>
            {isLoading ? (
                <Loading/>
            ) : (
                <>
                    <Box sx={{alignItems: 'center', width: '100%'}}>
                        <MuiAutocomplete
                            id="payment_discount_rate-select"
                            options={objs}
                            getOptionLabel={(option) => option.rate.toString()}
                            value={detailedObj ? detailedObj : null}
                            onChange={handleOnChange}
                            isOptionEqualToValue={(option, value) => option.id === value?.id && option.code === value?.code}
                            disableClearable={true}
                            renderInput={(params) => (
                                <TextField
                                    sx={{textTransform: 'capitalize'}}
                                    {...params}
                                    label={label ? t(label) : '' || t('payment_discount_rate')}
                                    required={required}
                                />
                            )}
                        />
                    </Box>
                </>
            )}
        </>
    );
}

export default PaymentDiscountRateSelect;